import { LoadingContainer } from "components";
import React, { ReactElement } from "react";
import { Navigate, Outlet } from "react-router";
import { useGetAuthQuery } from "store/api/auth.api";
import { appConfig } from "utils/constants";

import { pages } from "utils/routrer-utils";

interface OldProtectedRouteProps {
  children: ReactElement;
}

export const ProtectedRoute: React.FC = () => {
  const link = localStorage.getItem(appConfig.AUTH_LINK);
  const { isError, isSuccess, isLoading } = useGetAuthQuery(
    localStorage.getItem(appConfig.AUTH_LINK)
  );

  if (!link) return <Navigate to={pages.LOGIN} replace />;
  if (isLoading) return <LoadingContainer />;
  if (isError) return <Navigate to={pages.LOGIN} replace />;

  return isSuccess && <Outlet />;
};

export const OldProtectedRoute: React.FC<OldProtectedRouteProps> = ({
  children,
}) => {
  const link = localStorage.getItem(appConfig.AUTH_LINK);
  const { isError, isSuccess, isLoading } = useGetAuthQuery(
    localStorage.getItem(appConfig.AUTH_LINK)
  );

  if (!link) return <Navigate to={pages.LOGIN} replace />;
  if (isLoading) return <LoadingContainer />;
  if (isError) return <Navigate to={pages.LOGIN} replace />;

  return isSuccess && children;
};
